// extracted by mini-css-extract-plugin
export default {"addhoverButton":"VerificationNew_addhoverButton__N2940","verifyButton":"VerificationNew_verifyButton__TyrhK"};